import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { NGXLogger } from 'ngx-logger';
import { firstValueFrom, tap } from 'rxjs';

import { ValidationService } from '../../utils/valibot/validation.service';
import { ImageUrlResult, ImageUrlResultSchema } from './model/image-url-result.model';

@Injectable({
  providedIn: 'root',
})
export class VehicleImageClient {
  private static readonly urlPrefix = `image`;

  private readonly http = inject(HttpClient);
  private readonly logger = inject(NGXLogger);
  private readonly validationService = inject(ValidationService);

  getVehicleImageUrl(vin: string): Promise<ImageUrlResult> {
    const url = `${VehicleImageClient.urlPrefix}/${vin}`;

    this.logger.info(`#CDFFF0236 Fetching image URL for a vehicle: ${url}`);
    return firstValueFrom(
      this.http.get(url).pipe(
        this.validationService.pipeResponse(ImageUrlResultSchema),
        tap({
          error: (error: HttpErrorResponse) => {
            this.logger.error('#CDFTF0237 Unable to fetch image URL for a vehicle', error);
          },
        }),
      ),
    );
  }
}
